import React, { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux'
/**
 * Global style of the "appbar"
 */
const useStyles = makeStyles({
	root: {
		width: '100%',
	},
	flex: {
		flex: 1,
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20,
	},
});

/**
 * @classdesc
 * Create the application top bar
 */
export default function MyAppBar() {
	const classes = useStyles();

	const [opened, setOpened] = useState(false);
	const cart = useSelector(state => state.app.cart)
	/**
	 * Render the component
	 */

	return (
		<div>
			<AppBar className={classes.root}>
				<Toolbar>
					<Typography type="title" component={Link} to='/' color="inherit" style={{ textDecoration: 'none', fontSize: 30 }}>
						<img style={{ verticalAlign: 'middle' }} src='img/logo.png' alt="logo" />&nbsp;
						Cartorion
					</Typography>
					<div className={classes.flex} />
					<Button component={Link} to='/editor' color="inherit"> Editor</Button>
					<Button component={Link} to='/faq' color="inherit"> FAQ</Button>
					<Button onClick={() => { setOpened(true) }} color="inherit"> Contact</Button>
					<Button component={Link} to='/cart' color="inherit">Cart({cart.length})</Button>
				</Toolbar>
			</AppBar>
			<Dialog
				open={opened}
				onClose={() => { setOpened(false) }}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title"><Icon style={{ fontSize: 26, verticalAlign: 'bottom' }}>mail</Icon>&nbsp;Contact Us</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						If you encounter a problem, need some help or wish to give us feedback, please, send an email at <b>support@cartorion.com</b>.
						We will do our best to quickly answer your inquiery.
					</DialogContentText>
					<DialogActions>
						<Button color="primary" onClick={() => { setOpened(false) }}> Close</Button>
					</DialogActions>
				</DialogContent>

			</Dialog>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/MyAppBar.js